<div class="wrapper">
  <header class="l-header">
    <div class="on-mobile header-logo">
      <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
    </div>
    <div class="l-header-panel">
      <ng-container *ngIf="es.ExamType">
        <h1 class="t-title-main" style="margin-right: 32px">
          {{ "exam.type.Eyes." + es.ExamType | translate }}
          <span *ngIf="es.changedTitle">({{ es.newTitle }})</span>
          {{ pat.ID != "default" ? (es.CreationTime | date : "dd/MM/yyyy") : "Defaults" }}
        </h1>
      </ng-container>
      <nav class="header-menu" *ngIf="pat">
        <ng-container *ngIf="pat.ID != 'default'">
          {{ messages }}
          <a
            class="header-menu-link"
            [ngClass]="isRecording() ? 'icon-stop' : 'icon-record'"
            aria-label="Record"
            (click)="record()"
            *ngIf="
              !es.isClosed &&
              !es.isForm &&
              Stream &&
              (ls.ishospital || (ls.premissions && ls.premissions.VideoRecording))
            "
            matTooltip="Start/Stop Recording"
          ></a>
          <span
            (click)="showprintopts = true; showprint = true"
            class="header-menu-link icon-print"
            aria-label="Print"
            matTooltip="Print"
            *ngIf="es.ExamType != 'Emergency Room' && (es.signed || es.ExamType == 'Consultation Letter')"
          ></span>
          <span
            (click)="showprintopts = false; showprint = true"
            class="header-menu-link icon-searchdoc"
            aria-label="Print Preview"
            matTooltip="Print Preview"
            *ngIf="!es.signed"
          ></span>
          <div *ngIf="es.signed">
            <span
              class="header-menu-link"
              [ngClass]="sendonce ? 'icon-link-sent' : 'icon-link'"
              aria-label="Link"
              (click)="showlink = true"
              matTooltip="Send Weblink to patient"
              *ngIf="
                (ls.premissions && ls.premissions.Links && !ls.isCardio) || (ls.isCardio && es.signed)
              "
            ></span>
            <span
              *ngIf="ls.premissions.LinkLimit"
              style="align-self: center; margin-inline-start: 2.31em"
              [ngClass]="ls.linksent >= ls.premissions.LinkLimit ? 'error' : ''"
              >{{ ls.linksent }}/{{ ls.premissions.LinkLimit }}</span
            >
          </div>
          <ng-container *ngIf="!es.isForm">
            <a
              class="header-menu-link"
              [ngClass]="messages != 'Creating Disk ...' ? 'icon-save' : 'icon-busy'"
              aria-label="Disk"
              (click)="getDisk()"
              matTooltip="Burn CD"
            ></a>
            <span
              class="header-menu-link icon-image"
              aria-label="Images"
              (click)="showgallery = !showgallery"
              matTooltip="Open Gallery"
            ></span>
            <span
              class="header-menu-link icon-chart"
              *ngIf="!ls.isCardio"
              aria-label="Charts"
              (click)="showcharts = true"
              matTooltip="Show Charts"
            ></span>
            <span
              class="header-menu-link icon-inbox"
              aria-label="Inbox"
              (click)="showInbox = !showInbox"
              [matTooltip]="es.dicomConfigured ? 'Open DICOM Inbox' : 'Open Inbox'"
            ></span>

            <a class="header-menu-link icon-searchdoc" aria-label="Search" *ngIf="false"></a>
            <span
              *ngIf="!es.isClosed && vidMinified && Stream"
              (click)="vidMinified = false"
              style="margin-left: 2em"
            >
              <video id="minviewer" style="height: 35px" playsinline autoplay [srcObject]="Stream"></video>
              <div style="position: absolute; color: white; font-size: 7pt; margin-top: -4.5em">
                {{ ts.time }}
              </div>
            </span>
          </ng-container>
        </ng-container>
        <a
          class="header-menu-link icon-confirm"
          aria-label="Confirm"
          (click)="exit(true)"
          [matTooltip]="pat.ID != 'default' ? 'Close Exam and Open AWL' : 'Exit Defaults'"
        ></a>
      </nav>

      <nav class="on-mobile header-mobilePanel">
        <button class="btn-mobileMenu" id="open-headerMenu" data-show=".header-menu"></button>
        <button class="btn-mobileMenu" id="open-mainNav" data-show=".l-sidebar"></button>
      </nav>
    </div>
  </header>

  <div class="exam-element">
    <div class="topbar" *ngIf="!es.OpenerName || es.ExamType != 'Emergency Room'"></div>
    <div class="topbar" *ngIf="es.OpenerName && es.ExamType == 'Emergency Room'">
      Examined By: {{ es.OpenerName }}
    </div>
    <main class="l-deashboard">
      <app-eyes-general *ngIf="page == 'Introduction'"></app-eyes-general>
      <app-cardio-summary *ngIf="page == 'Introduction'"></app-cardio-summary>
      <app-gallerybox
        *ngIf="showgallery"
        (closed)="showgallery = false; CurrentInbox = null"
        (closeall)="showgallery = false; CurrentInbox = null; showInbox = false"
        [inbox]="CurrentInbox"
      ></app-gallerybox>
      <app-charts *ngIf="showcharts" (closed)="showcharts = false" [page]="page"></app-charts>
      <app-inbox
        *ngIf="showInbox && !es.dicomConfigured"
        (closed)="showInbox = false"
        (openg)="openGallery($event)"
      ></app-inbox>
      <app-dicom-inbox
        *ngIf="showInbox && es.dicomConfigured"
        (closed)="showInbox = false"
      ></app-dicom-inbox>
      <app-printopts
        *ngIf="showprint"
        (closed)="showprint = false"
        [showopts]="showprintopts"
      ></app-printopts>
      <app-send-link
        *ngIf="showlink"
        (closed)="showlink = false; sendonce = true; ls.countLinks()"
        [exam]="null"
      ></app-send-link>
      <app-gallery
        style="width: 100%"
        [forprint]="false"
        [inbox]="null"
        *ngIf="es.ExamType == 'Emergency Room'"
      ></app-gallery>
      <app-twod *ngIf="page == '2D Measurements'"></app-twod>
      <app-cardio-doppler *ngIf="page == 'Doppler'"></app-cardio-doppler>
      <app-cardio-tissue-dop *ngIf="page == 'Tissue Doppler'"></app-cardio-tissue-dop>
      <app-preparation *ngIf="page == 'Preparation'"></app-preparation>
      <app-pathologies *ngIf="page == 'Pathologies'"></app-pathologies>
      <app-gastro-procedure *ngIf="page == 'ProcedureGastro'"></app-gastro-procedure>
      <app-gastro-summary *ngIf="page == 'SummaryGastro'"></app-gastro-summary>
      <app-commerror></app-commerror>
    </main>
  </div>
  <app-informconcent
    *ngIf="inform"
    (closed)="closeConcent($event)"
    [form]="concentForm"
    [ExamType]="es.ExamType"
  ></app-informconcent>

  <aside class="l-moreInfo" *ngIf="es.ShowSRs">
    <div class="moreInfo-partialyObscured">
      <section class="m-box">
        <h2>Structured reports</h2>
        <p>
          <ng-container *ngFor="let sr of es.SRList; let i = index">
            <span (click)="loadSR(sr)" [ngClass]="CurrentSR == sr ? 'srselected' : 'sritem'">{{
              i + 1
            }}</span
            >&nbsp;
          </ng-container>

          <iframe
            *ngIf="CurrentSR"
            [srcdoc]="SR"
            style="width: 100%; height: 63vh; padding-bottom: 2em"
          ></iframe>
        </p>
      </section>
    </div>
  </aside>

  <app-examsbar (pageChange)="setPage($event)" (showPatDetails)="showPat = true"></app-examsbar>
  <app-patdetails *ngIf="showPat" [pat]="pat" (closed)="showPat = false"></app-patdetails>
  <app-bottombar></app-bottombar>
</div>
<app-autotext *ngIf="atS.Display"></app-autotext>

<div
  style="position: absolute; bottom: 0; right: 0; z-index: 100"
  *ngIf="!es.isClosed && ls.Recording == 'webrtc' && !vidMinified"
>
  <div style="position: absolute; top: 0; left: 0">
    <img
      src="../../assets/icons/minimize.svg"
      style="width: 30px"
      (click)="vidMinified = true"
      matTooltip="Minimize"
    />
    <img
      src="../../assets/icons/maximize.svg"
      style="width: 30px"
      (click)="maximizeVid()"
      matTooltip="Full Screen"
    />
  </div>

  <span #videobox (fullscreenchange)="togglefullscreen()">
    <video
      playsinline
      autoplay
      [srcObject]="Stream"
      *ngIf="Stream"
      #video
      [class]="fullscreen ? 'fullscreen' : 'vscreen'"
    ></video>
    <div
      style="
        font-size: 22pt;
        color: white;
        position: absolute;
        margin-top: -5em;
        z-index: 200;
        direction: ltr;
      "
      *ngIf="isRecording()"
    >
      {{ ts.time }}
    </div>
  </span>
  <div style="position: absolute; margin-top: -5em; z-index: 200; color: white; direction: ltr">
    <span *ngIf="!isRecording() && !ls.RemoteRTC">
      <div>
        <select [(ngModel)]="videoSource" (change)="startVideo()">
          <ng-container *ngFor="let item of videoInputs">
            <option [value]="item.value">{{ item.text }}</option>
          </ng-container>
        </select>
      </div>
      <select [(ngModel)]="audioSource" (change)="startVideo()">
        <ng-container *ngFor="let a of audioInputs">
          <option [value]="a.value">{{ a.text }}</option>
        </ng-container>
      </select>
      Sound Test <input type="checkbox" [(ngModel)]="soundtest" [value]="true" (change)="startVideo()" />
    </span>

    <span style="color: red; display: none" *ngIf="videowarn">No Video Device found!</span>
  </div>
</div>
<div *ngIf="showgallery && gs.isOpen" [ngClass]="gs.mode == 'pdf' ? 'deletePdf' : 'deletePic'">
  <img
    style="width: 30px; cursor: pointer"
    title="Delete this"
    (click)="showdeleteimg = true"
    src="../../assets/icons/delete.svg"
  />
  <span style="color: white" *ngIf="showdeleteimg"
    >Are you sure you want to delete this?
    <span (click)="deleteMedia()" style="cursor: pointer; margin-left: 1em">YES</span>&nbsp;<span
      (click)="showdeleteimg = false"
      style="cursor: pointer; margin-left: 1em"
      >NO</span
    ></span
  >
</div>
<canvas #imgcanvas style="position: absolute; top: 0; left: 0; z-index: 1020" *ngIf="ls.isGastro">
</canvas>
